// @flow
import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

import { withGlobalContext } from "../common/GlobalContext";
import type { CompliantListingType } from "flow/types";

type Props = {
  classes: Object,
  className: string,
  compliance: Object,
  complianceKey: string,
  listing: CompliantListingType,
};

const Disclaimer = ({
  classes,
  className,
  compliance,
  complianceKey,
  listing,
}: Props) => {
  if (!(listing.compliance && listing.compliance[complianceKey])) {
    return null;
  }

  return (
    <div className={classNames(classes.root, className)}>
      {/* COMPLIANCE: Some MLSes require their logo displayed with the disclaimer */}
      {compliance &&
        compliance.watermark && (
          <img
            src={compliance.watermark}
            alt="Logo"
            style={{ maxWidth: "140px", marginBottom: "12px" }}
          />
        )}
      <div
        id={`ref__${complianceKey}`}
        dangerouslySetInnerHTML={{
          __html: listing.compliance[complianceKey],
        }}
      />
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "520px",
    color: theme.colors.gray["900"],
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: "600",
    margin: "0 auto 12px",
  },
}))(withGlobalContext(Disclaimer));
